import { assessorSchema } from "@/schema/console/assessors/Assessor";
import { z } from "zod";

export const assessorCreateSchema = assessorSchema
  .omit({ id: true, companies: true })
  .extend({
    company_ids: z.array(z.number()),
    password: z.string().min(8),
  });

export type AssessorCreate = z.infer<typeof assessorCreateSchema>;
